<script setup lang="ts">
import { onUnmounted, onMounted, ref, computed } from 'vue'
import Dashboard from './Dashboard.vue'
import DataTable from './datatable/DataTable.vue'
import SplitDataTable from './datatable/SplitDataTable.vue'
import TabbedDataTable from './datatable/TabbedDataTable.vue'
import Tasks from './Tasks.vue'
import RolesRights from './RolesRights.vue'
import GefahrstoffDetailSheet from './GefahrstoffDetailSheet.vue'
import LogsView from './Logs.vue'
import GefahrstoffForm from './GefahrstoffForm.vue'
import axios from "axios"
import AppSidebar from '@/components/AppSidebar.vue'
import { storeToRefs } from "pinia"
import { useEntityStore } from "@/stores/useEntityStore"
import EditorPanel from './datatable/EditorPanel.vue'
import SingleSelect from './datatable/SingleSelect.vue'
import RgStandardTexts from './RgStandardTexts.vue'
import {
  SidebarInset,
  SidebarProvider,
} from '@/components/ui/sidebar'
import { useViewStore } from '@/stores/viewStore'
import { PieChart,UsersRound,
MapPin,
Import,
BookOpenText,
Pyramid,
CircleUserRound,
SendHorizontal,
FileSpreadsheet,
Quote,
Workflow,
MessageCircle,
MessageCirclePlus
} from "lucide-vue-next";
import RechtsgrundlagenLogo from '@/components/images/rechtsgrundlagen.svg'
import PflichtenLogo from '@/components/images/pflichten.svg'

import { Button } from "@/components/ui/button"
import { todayISO, applyMatrixChange, sendNotification, generateExcel, get_data_attr, getRgId, getRgTitle, getRgPflichtenLabel, getRgStandardTextsLabel } from '@/utils/globals'
import rkIconUrl from '@/components/images/rk.svg?url'
import { useToast, Toaster } from "@/components/ui/toast"
   
import { useI18n } from 'vue-i18n';
import StandortSelect from './StandortSelect.vue'

const { t } = useI18n();

const { toast } = useToast()

const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
if (token) axios.defaults.headers.common["X-CSRF-Token"] = token

const datarechtsgrundlagen = ref([])
const datakunden = ref([])
const datafunctions = ref([])
const datausers = ref([])
const isLoading = ref(true)

const customerInfo = get_data_attr("customer");
const userInfo = get_data_attr("user");
const viewStore = useViewStore();

const selectedRgId = ref(null)

const rgTable = ref<InstanceType<typeof TabbedDataTable> | null>(null);
const splitRgRef = ref<InstanceType<typeof SplitDataTable>>(null);
const splitPfRef = ref<InstanceType<typeof SplitDataTable>>(null);
const splitSubPfRef = ref<InstanceType<typeof SplitDataTable>>(null);
const rgSubTab = ref(null)
const rgFullRow = ref(null)
const splitTaskAssignment = ref(false)

const props = defineProps({
  specsInfo: { type: Object },
});

const emit = defineEmits<{
  (e: 'reset'): void;
}>();


// Create a computed property for actionView that syncs with viewStore
const actionView = computed({
  get: () => viewStore.actionView,
  set: (value) => {
    viewStore.actionView = value;
  }
});


async function getDataUrl(url) {
  try {
    const response = await fetch(url);
    const data = await response.json();
    console.log('Received data!', data);
    return data;
  } catch (error) {
    console.error('Error fetching data!', error);
    return null;
  }
}

async function getData(category, all=false): Promise<Project[]> {
  return getDataUrl('/' + category + '.json' + (all ? "?per_page=10000" : ""));
}


async function reload() {
	console.log("reload")
	if (viewStore.actionView == null) {
		viewStore.actionView = 'registry.dashboard';		
	}
	datarechtsgrundlagen.value = await getData('rechtsgrundlagen')
	if (customerInfo.is_hoeppner) {
	  datakunden.value = await getData('kunde', true)
	} else {
	  datafunctions.value = await getData('functions', true)
      datausers.value = await getData('users', true)
	}
	
	console.log("datafunctions.value=" + JSON.stringify(datafunctions.value.map(f => [f.id, f.functionname])))
	//colsbooking.filter(c => c.key === "user_id")[0].options = datausers.value.map(u => ({id: u.id, label: u.name}));
	//colsbooking.filter(c => c.key === "project_id")[0].options = dataprojects.value.map(p => ({id: p.id, label: p.name}));
	//colsuser.filter(c => c.key === "role_id")[0].options = dataroles.value.map(r => ({id: r.id, label: r.name}));
	isLoading.value = false	
}
onMounted(() => reload());

function setSelectedRgId(rgId) {
	selectedRgId.value = rgId;
}


async function sendpasswd(row) {
  if (!window.confirm('Möchten Sie wirklich dem User ' + row["email"] + ' das Kennwort senden?')) {
	return;
  }
  try {
	await axios.post(`/users/sendpwd/${row.id}`)	
    toast({ title: "Kennwort", description: "gesendet" })
  } catch (error) {
	const message =
	  error.response?.data?.message || // if your API returns JSON with "message"
	  error.response?.data?.error || // if your API returns JSON with "message"
	  error.response?.statusText ||   // fallback to status text
	  "Kennwort nicht gesendet."
	toast({ title: "Kennwort nicht gesendet", description: message, variant: "destructive" })	
  }
}

const isDownloading = ref(false)

async function generateexcel(row, is_quentic=false) {
  generateExcel(axios, `/excel${is_quentic ? 'quentic' : ''}/${row.id}`, toast, isDownloading)
}

async function do_workflow(row, clear=false) {
  if (!window.confirm('Möchten Sie wirklich den Workflow des Kunden ' + row["Kunde"] + ` ${clear ? ' zurück setzen?' : ' aktualisieren?'}`)) {
	return;
  }
  try {
	await axios.post(`/updateworkflows/${row.id + (clear ? '?clearworkflow=1' : '')}`)	
	toast({ title: "Workflow", description: clear ? "zurück gesetzt" : "aktualisiert" })
  } catch (error) {
	const message =
	  error.response?.data?.message || // if your API returns JSON with "message"
	  error.response?.data?.error || // if your API returns JSON with "message"
	  error.response?.statusText ||   // fallback to status text
	  "Workflow aktualisierung gescheitert."
	toast({ title: "Workflow aktualisierung gescheitert", description: message, variant: "destructive" })
  }
}

// Computed properties for assignment labels (reactive to locale changes)
const cust_assignment_text = computed(() => t('view.customer_assignment'));
const function_assignment_text = computed(() => t('view.function_assignment'));

function getAssignmentLabel(customerInfo) {
	return customerInfo.is_hoeppner ? cust_assignment_text.value : function_assignment_text.value;
}

function showHideText(customerInfo, show) {
	const actionText = show ? t('view.hide') : t('view.edit');
	return `${actionText} ${getAssignmentLabel(customerInfo)}`;
}


function status_options(type) {
	const colors_status = get_data_attr("colors_status_" + type);
	return get_data_attr("choice_status_" + type).map(status => ({id: status[1], label: status[0], bgcolor: colors_status[status[1]]}));
}

function getAssignmentColumns(customerInfo, type) {
  if (customerInfo.is_hoeppner) {
	let kundecols =  datakunden.value.filter(k => k.id_kunde !== 10).map(k => ({key: "assignment." + k.id_kunde, kid: k.id_kunde, standorts: k.standorts, label: k.Kunde + "(" + k.id_kunde +  ")", togglefilter: true, type: 'boolean', show: true, write: true})).sort((a, b) => a.label.localeCompare(b.label))
	console.log("kundecols=" + JSON.stringify(kundecols))
	return kundecols
  } else {
	if (type === 'pflichten') {
      console.log('[getAssignmentColumns BEFORE map]', {
        endpoint: 'pflichten-sub-assignment',
        datafunctions: datafunctions.value.map(f => ({ id: f.id, functionname: f.functionname }))
      })
    }
	const cols = datafunctions.value.map(f => ({key: "assignment." + f.id, label: f.functionname + "(" + f.id + ")", type: 'select', togglefilter: true, show: true, write: true, options:status_options(type), width: '160px'})).sort((a, b) => a.label.localeCompare(b.label))
	console.log("[getAssignmentColumns SNAPSHOT]", JSON.parse(JSON.stringify(cols)))
	console.log("[getAssignmentColumns]", { type, cols })

	return cols	
  }
}

function getAssignmentColumnsNotifications(type) {
	console.log("getAssignmentColumnsNotifications=" + JSON.stringify(datafunctions.value.map(f => ({id: f.id, label: f.functionname}))))
	return [{key: 'id'    , label: 'Funktion', type: 'select', show: true, write: false, options: datafunctions.value.map(f => ({id: f.id, label: f.functionname}))}, 
	        {key: "status", label: "Status"  , type: 'select', show: true, write: true , options: status_options(type), width: '160px'}]
}

function getAssignments(assignments) {
	console.log("getAssignments=" + JSON.stringify(assignments))
    return Object.entries(assignments).map(([k, v]) => ({ id: parseInt(k), status: v }));
}

const rightRgData = ref<any[]>([]);
const rightPfData = ref<any[]>([]);

async function applyNotificationAssignmentChange(change) {
//	change={"id":1300314,"path":"assignment.157","value":0}
	change["path"] = "assignment." + change.id
	change.id = selectedPflichtId.value
	applyMatrixChange(axios, toast, customerInfo, "pflichten", change, true) 
}



const splitterPflichtRef   = ref()
const selectedPflichtId    = ref(null)
const selectedPflicht      = ref(null)
const selectedNotification = ref(null)
const updatedNotification  = ref(0)
const entityStore = useEntityStore()
const { currentItem, showEditor } = storeToRefs(entityStore)


function setSelectedPflicht(row) {
	selectedPflichtId.value = row.id
	selectedPflicht.value = row
	
	console.log("setSelectedPflicht=" + JSON.stringify(row))

	if (!row.notification) {
	  row.notification = {}
	}
	
	if (!row.notification.id) {
		row.notification["title"] = row["Kurzbeschreibung / Überschrift"]
		row.notification["duedate"] = todayISO()
		row.notification["period"] = 0
		row.notification["is_notification"] = 1
		row.notification["originator_id"] = userInfo.id
		row.notification["pfm_id"] = row.pfm_id
		console.log("specsinfo tasks=" + JSON.stringify(props.specsInfo['tasks']))
	} 
	entityStore.openEditor('tasks', row.notification)
	
	//selectedNotification.value = 
}

function closeNotification() {
  console.log("closeNotification")
  //selectedPflicht.value = null;
  //selectedPflichtId.value = null;
  entityStore.closeEditor('tasks')
}

function saveNotification() {
  console.log("tasks")
  entityStore.saveEditor('tasks', 'tasks', () => {})
  //selectedPflicht.value = null;
  //selectedPflichtId.value = null;
  updatedNotification.value++	
}

const choice_notification = get_data_attr("choice_notification").map(status => ({id: status[1], label: status[0]}));

const is_notification = ref(-1)

const rgDataTable = ref(null)
const pfDataTable = ref(null)

async function filterNotificationRg(val) {
  rgDataTable.value?.onColumnFilterChange("is_notification", val)
}

async function filterNotificationPf(val) {
  pfDataTable.value?.onColumnFilterChange("is_notification", val)
}


function swapcol(endpoint, from, to) {
	console.log("swapcol endpoint=" + endpoint + " from=" + from + " to=" + to)
    emit('reset')
} 

function onResize(e: MouseEvent) {
  viewStore.forceRefresh()
}

async function handleCustomerStandort(standort_id, customer_id, rtype) {
  console.log("customer_id=" + customer_id + " standort_id=" + standort_id)
   try {
    const response = await axios.get(`/${rtype}/?kunde_id=${customer_id}&kunde_standort_id=${standort_id}`)
	if (rtype === "rechtsgrundlagen") {
      rightRgData.value = response.data
	} else {
      rightPfData.value = response.data
	}
  } catch (error) {
		const message =
	  error.response?.data?.message || // if your API returns JSON with "message"
	  error.response?.data?.error || // if your API returns JSON with "message"
	  error.response?.statusText ||   // fallback to status text
	  "Standort nicht gesetzt."
	toast({ title: "Standort nicht gesetzt", description: message, variant: "destructive" })	
  }
}

onMounted(() => window.addEventListener('resize', onResize))
onUnmounted(() => window.removeEventListener('resize', onResize))

console.log("tasks specsinfo=" + JSON.stringify(props.specsInfo['tasks'].map(s => s.key)))
</script>

<template>
  <SidebarProvider>

    <AppSidebar :actionView="actionView" @updateView="actionView = $event"/>
    <SidebarInset class="w-screen h-screen" style="overflow: auto">	  
		<div style="margin-left: unset; height: 100%; overflow-y: scroll; max-width: unset" :class="['container']">
		  <Dashboard v-if="viewStore.actionView === 'registry.dashboard'  && !isLoading" :icon="PieChart" :specsInfo="props.specsInfo"/>
		  <TabbedDataTable :key="viewStore.refreshKey" ref="rgTable" v-if="viewStore.actionView === 'registry.rechtsgrundlagen'  && !isLoading"
		             label="view.rechtsgrundlagen" :logo="rkIconUrl" endpoint="rechtsgrundlagen"
					 :columns="specsInfo['rechtsgrundlagen']">
			<template #maincontent>
				<SplitDataTable ref="splitRgRef">
					<template #left>
				        <DataTable ref="rgDataTable" label="view.rechtsgrundlagen" 
						           labelSingular="view.rechtsgrundlage"
						           :logo="rkIconUrl"
								   endpoint="rechtsgrundlagen"
								   v-bind="{ ...(!customerInfo.is_hoeppner ? { saveendpoint: 'rechtsgrundlagenmatrix' } : {}) }"
						           :columns="specsInfo['rechtsgrundlagen']"
								   :enableAdd="customerInfo.is_hoeppner"
								   :enableDelete="customerInfo.is_hoeppner"
								   :headerFontSize="14"
								   @swapcol="swapcol"
						           @page-loaded="rightRgData = $event">
					        <template #logo><RechtsgrundlagenLogo  class="w-8 h-8"/></template>
							<template #extraglobalactions>
								 
								<button
								  @click="splitRgRef?.toggleRight(false)"
								  class="greenbutton text-white rounded w-60 h-9"
								>
								  {{ showHideText(customerInfo, splitRgRef?.showRight) }}
								</button>
							</template>
					        <template #extraactions="{row}">
						        <Button :disabled="row.standardtexts.length === 0"
										:class="[row.standardtexts.length > 0 ? 'text-green-600' : 'text-black-600', 'hover:bg-blue-50' ]"

								        :title="t('view.btn_rg_standardtexts', {rg: getRgTitle(row)})" size="sm" variant="outline" @click="rgSubTab = 2; rgFullRow = row; rgTable?.openRowTab(getRgId(row), getRgStandardTextsLabel(row))">
							          <BookOpenText />
						        </Button>
						        <Button :title="t('view.btn_rg_pflichten', {rg: getRgTitle(row)})" size="sm" variant="outline" @click="rgSubTab = 1; rgTable?.openRowTab(getRgId(row), getRgPflichtenLabel(row))">
							          <PflichtenLogo />
						        </Button>
					        </template>
				        </DataTable>
					</template>
				   <template #right>
				      <DataTable :label="getAssignmentLabel(customerInfo)" :logo="rkIconUrl"
					    :data="rightRgData" :columns="getAssignmentColumns(customerInfo, 'rechtsgrundlagen')"
					     @cell-changed="(change) => applyMatrixChange(axios, toast, customerInfo, 'rechtsgrundlagen', change, true)"
					     @cell-notified="(change) => sendNotification(axios, toast, customerInfo, 'rechtsgrundlagen', change, true)"
					    :enableAdd="false"
					    :enableEdit="false"
					    :enableDetail="false"
					    :enableDelete="false"
						:enableFilter="false"
						:enableColChange="false"
						:enableCopy="false"
						:enableNotifications="true"
						:alwaysEdit="true"
						:withpaging="false"
						:headerFontSize="12"
						:singleSelectFontsize="12"
						:enableColFilterSide="false"
						:enableColFilterTop="true"
						:hideActionColumn="true"
						:enableAll="true"
						>
				        <template #logo><RechtsgrundlagenLogo  class="w-8 h-8"/></template>
					    <template #colextensions="{col}">
							<div v-if="col.standorts && col.standorts.length > 0" >
							  <StandortSelect :items="col.standorts.map(s => ({value: s.id, label: s.displayname}))" @change="value => handleCustomerStandort(value, col.kid, 'rechtsgrundlagen')" />
							</div>
						</template>
				      </DataTable>
				  </template>
				</SplitDataTable>
			</template>
		    <template #tabbedcontent="{row}">
			   <div v-if="rgSubTab === 2">
				<RgStandardTexts :standardTexts="rgFullRow.standardtexts" />
			   </div>
			   <SplitDataTable v-if="rgSubTab === 1" ref="splitSubPfRef"  :key="viewStore.refreshKey">
		  	      <template #left>
				    <DataTable label="view.pflichten"
					             :logo="rkIconUrl"
				                 endpoint="pflichten"
				                 :endpointpars="{id_rechtsgrundlagen: row}"
								 v-bind="{ ...(!customerInfo.is_hoeppner ? { saveendpoint: 'pflichtenmatrix' } : {}) }"
								 :columns="specsInfo['pflichten']"
						         :enableAdd="false"
						         :enableEdit="true"
						         :enableDetail="false"
						         :enableDelete="false"
								 @page-loaded="rightPfData = $event"
						  >
				          <template #logo><PflichtenLogo class="w-8 h-8" /></template>

						  <template #extraglobalactions>
						      <SingleSelect v-if="!customerInfo.is_hoeppner && userInfo.has_notification"
						          :fontSize="props.singleSelectFontsize ? props.singleSelectFontsize : undefined"
						          :options="choice_notification"
						          :modelValue="is_notification"
						          @update:modelValue="filterNotificationPf"
						      />
			   	              <button @click="splitSubPfRef?.toggleRight(false)" class="greenbutton text-white rounded w-60 h-9">
			   	                 {{ showHideText(customerInfo, splitSubPfRef?.showRight) }}
			   	              </button>
			              </template>

				    </DataTable>
		          </template>
				  <template #right>
					<DataTable :label="getAssignmentLabel(customerInfo)" :logo="rkIconUrl" :data="rightPfData" :columns="getAssignmentColumns(customerInfo, 'pflichten')"
		  	          @cell-changed="(change) => applyMatrixChange(axios, toast, customerInfo, 'pflichten', change, true)"
				      @cell-notified="(change) => sendNotification(axios, toast, customerInfo, 'pflichten', change, true)"
		  	          :enableAdd="false"
		  	          :enableEdit="false"
		  	          :enableDetail="false"
		  	          :enableDelete="false"
			          :enableFilter="false"
				      :enableColChange="false"
		  		      :alwaysEdit="true"
				      :headerFontSize="12"
				      :singleSelectFontsize="12"
				      :enableColFilterSide="false"
				      :enableColFilterTop="true"
				      :enableCopy="false"
				      :enableNotifications="true"
				      :enableAll="true"
				      :hideActionColumn="true"
		  		      :withpaging="false">
		          <template #logo><PflichtenLogo   class="w-8 h-8" /></template>
		        </DataTable>

		          </template>
				</SplitDataTable>
			</template>

		  </TabbedDataTable>
		  
		  <SplitDataTable :key="viewStore.refreshKey" ref="splitPfRef" v-if="viewStore.actionView === 'registry.pflichten'  && !isLoading">
		  	<template #left>
				  <DataTable ref="pfDataTable"  
				            label="view.pflichten"
				            :key="updatedNotification"
				            labelSingular="view.pflicht"
				            :logo="rkIconUrl"
				            endpoint="pflichten"
							v-bind="{ ...(!customerInfo.is_hoeppner ? { saveendpoint: 'pflichtenmatrix' } : {}) }"
							:columns="specsInfo['pflichten']"
							:enableAdd="customerInfo.is_hoeppner"
							:enableDelete="customerInfo.is_hoeppner"
							@swapcol="swapcol"
							@page-loaded="rightPfData = $event">
				    <template #logo><PflichtenLogo   class="w-8 h-8" /></template>
			        <template #extraglobalactions>
						<SingleSelect v-if="!customerInfo.is_hoeppner && userInfo.has_notification"
						  :fontSize="props.singleSelectFontsize ? props.singleSelectFontsize : undefined"
						  :options="choice_notification"
						  
						  :modelValue="is_notification"
						  @update:modelValue="filterNotificationPf"
						/>
			   	       <button
			   	           @click="splitPfRef?.toggleRight(false)"
			   	           class="greenbutton text-white rounded w-60 h-9"
			           >
			   	       {{ showHideText(customerInfo, splitPfRef?.showRight) }}
			   	      </button>
			        </template>
				    <template v-if="!customerInfo.is_hoeppner && customerInfo.has_notification && userInfo.has_notification" #extraactions={row}>
					  <Button v-if="row.notification?.id" :title="t('view.btn_notification')" size="sm" variant="outline" class="text-black-600 hover:bg-blue-50"
					     @click.stop
					     @click="() => setSelectedPflicht(row)">
					    <MessageCircle />
					  </Button>
				      <Button v-if="!row.notification?.id" :title="t('view.btn_notification_add')" size="sm" variant="outline" class="text-black-600 hover:bg-blue-50"
					     @click.stop
					     @click="() => setSelectedPflicht(row)">
				        <MessageCirclePlus />
				      </Button>
				     </template>
		        </DataTable>

				<EditorPanel v-if="showEditor['tasks']"
							:columns="specsInfo['tasks'].filter(s => s.key !== 'datascope')"
							:label="t('view.edit_notification')"
							:currentItem="currentItem['tasks']"
							endpoint="props.endpoint" 
							@close-editor="closeNotification()"
							@save-editor="saveNotification()">
					<template #extra={item}>
					
					<DataTable :label="t('view.assignment')" :logo="rkIconUrl"
						:data="getAssignments(selectedPflicht.assignment)" :columns="getAssignmentColumnsNotifications('pflichten')"
						@cell-changed="(change) => applyNotificationAssignmentChange(change)"
						:enableAdd="false"
						:enableEdit="false"
						:enableDetail="false"
						:enableDelete="false"
						:enableFilter="false"
						:enableColChange="false"
						:alwaysEdit="true"
						:withpaging="false"
						:headerFontSize="12"
						:singleSelectFontsize="12"
						:enableColFilterSide="false"
						:enableColFilterTop="false"
						:hideActionColumn="true"
					>
					</DataTable>

					</template>
				</EditorPanel>

		  	</template>
		     <template #right>
		        <DataTable :label="getAssignmentLabel(customerInfo)" :logo="rkIconUrl" :data="rightPfData" :columns="getAssignmentColumns(customerInfo, 'pflichten')"
		  	     @cell-changed="(change) => applyMatrixChange(axios, toast, customerInfo, 'pflichten', change, true)"
				 @cell-notified="(change) => sendNotification(axios, toast, customerInfo, 'pflichten', change, true)"
		  	    :enableAdd="false"
		  	    :enableEdit="false"
		  	    :enableDetail="false"
		  	    :enableDelete="false"
				:enableFilter="false"
				:enableColChange="false"
		  		:alwaysEdit="true"
				:headerFontSize="12"
				:singleSelectFontsize="12"
				:enableColFilterSide="false"
				:enableColFilterTop="true"
				:enableCopy="false"
				:enableNotifications="true"
				:enableAll="true"
				:hideActionColumn="true"
		  		:withpaging="false">
		          <template #logo><PflichtenLogo   class="w-8 h-8" /></template>
				  <template #colextensions="{col}">
					<div v-if="col.standorts && col.standorts.length > 0" >
					  <StandortSelect :items="col.standorts.map(s => ({value: s.id, label: s.displayname}))" @change="value => handleCustomerStandort(value, col.kid, 'pflichten')" />
					</div>
				 </template>
		        </DataTable>
		    </template>
		  </SplitDataTable>
		  
		  
		  <Tasks  :key="viewStore.refreshKey" v-if="viewStore.actionView === 'registry.tasks' && !isLoading" :specsInfo="specsInfo" @swapcol="swapcol" />

          <DataTable v-if="viewStore.actionView === 'registry.customers' && !isLoading"
					 label="view.customers"
					 labelSingular="view.customer"
					 :logo="rkIconUrl" endpoint="kunde"
					 :columns="specsInfo['kunde']"
		             @swapcol="swapcol">
			<template #logo><CircleUserRound /></template>
		    <template #extraactions="{row}">
		      <Button :title="t('view.btn_excel')" size="sm" variant="outline" @click="() => generateexcel(row)">
		        <FileSpreadsheet />
		      </Button>
		      <Button :title="t('view.btn_quenticexcel')" size="sm" variant="outline" @click="() => generateexcel(row, true)">
		        <Quote />
		      </Button>
		      <Button :title="t('view.btn_workflow')" size="sm" variant="outline" @click="() => do_workflow(row)" class="text-green-600 hover:bg-blue-50">
		        <Workflow />
		      </Button>
		      <Button :title="t('view.btn_workflow_clear')" size="sm" variant="outline" @click="() => do_workflow(row, true)" class="text-red-600 hover:bg-blue-50">
		        <Workflow />
		      </Button>
		    </template>
		  </DataTable>
		  <LogsView v-if="viewStore.actionView === 'registry.logs' && !isLoading" />
	      <DataTable v-if="viewStore.actionView === 'registry.users' && !isLoading"
				   	label="view.users"
					labelSingular="view.user"
                    :logo="rkIconUrl" endpoint="users"
				  	:columns="specsInfo['users']">
			<template #logo><UsersRound /></template>
		    <template #extraactions="{row}">
			    <Button :title="t('view.btn_sendpasswd')" size="sm" variant="outline" @click="() => sendpasswd(row)">
				    <SendHorizontal />
			    </Button>
		    </template>
		  </DataTable>
		  <RolesRights v-if="viewStore.actionView === 'registry.roles' && !isLoading"/>
          <DataTable v-if="viewStore.actionView === 'registry.standorts' && !isLoading"
				    label="view.standorts"
					labelSingular="view.standort"
                    :logo="rkIconUrl" endpoint="standorts"
					:columns="specsInfo['standorts']"
					@swapcol="swapcol"
					:enableDetail="false">
			<template #logo><MapPin /></template>
		  </DataTable>
		  <DataTable v-if="viewStore.actionView === 'registry.functions' && !isLoading"
				    label="view.functions"
					labelSingular="view.function"
					:logo="rkIconUrl" endpoint="functions"
					:columns="specsInfo['functions']"
					@swapcol="swapcol"
					:enableDetail="false">
			<template #logo><Pyramid /></template>
		  </DataTable>
		  <DataTable v-if="viewStore.actionView === 'registry.imports' && !isLoading"
				    label="view.imports"  :logo="rkIconUrl" endpoint="imports"
					:columns="specsInfo['imports']"
					@swapcol="swapcol">
			<template #logo><Import /></template>					
		  </DataTable>
		  
		  <!-- Gefahrstoffe list + detail sheet layout -->
		  <GefahrstoffDetailSheet
		    :key="viewStore.refreshKey"
		    v-if="viewStore.actionView === 'registry.gefahrstoffe' && !isLoading"
		  />
		  
		  <!-- Gefahrstoffe form views (new/edit) -->
		  <GefahrstoffForm 
			v-if="(viewStore.actionView === 'registry.gefahrstoffe.new' || viewStore.actionView?.startsWith('registry.gefahrstoffe.edit.')) && !isLoading"
			:id="viewStore.actionView?.startsWith('registry.gefahrstoffe.edit.') ? parseInt(viewStore.actionView.split('.').pop()) : undefined"
		  />

		</div>
    </SidebarInset>
  </SidebarProvider>
</template>

<style>
.bg-black\/80 {
  background-color: transparent !important;
}
</style>